module.exports = __webpack_public_path__ + "img/IMG_0338.e5e8d047.png";